/**
 * Canonical analytics event names. Centralized so client + server fire the
 * same event names and so renames stay consistent.
 *
 * Naming: `snake_case`, past-tense verb where possible (`signup_completed`,
 * `coach_booked`).
 */

/** Existing — kept for back-compat with `captureCheckoutCompleteEvent`. */
export const CHECKOUT_COMPLETE_EVENT = 'checkout_complete';

/* --- Primary conversion events ---------------------------------------- */

/** New account creation (player or coach). Fires server-side at the end of signup. */
export const SIGNUP_COMPLETED_EVENT = 'signup_completed';

/** Player sent a message to a coach. Fires server-side at the messaging API. */
export const COACH_MESSAGE_SENT_EVENT = 'coach_message_sent';

/** Player booked a lesson with a coach. Fires server-side at booking complete. */
export const COACH_BOOKED_EVENT = 'coach_booked';

/** Player joined a tournament / event. Fires server-side at join. */
export const EVENT_JOINED_EVENT = 'event_joined';

/* --- Secondary engagement events -------------------------------------- */

/** Coach or organizer created a round robin / americano. */
export const ROUND_ROBIN_CREATED_EVENT = 'round_robin_created';

/** Newsletter subscription completed (Quatro newsletter API). */
export const NEWSLETTER_SUBSCRIBED_EVENT = 'newsletter_subscribed';

/** Player followed a coach. */
export const COACH_FOLLOWED_EVENT = 'coach_followed';

/** "Get started" CTA on coach page was clicked. Client-side. */
export const COACH_GET_STARTED_CLICKED_EVENT = 'coach_get_started_clicked';

/** "Check the location" button on tournament pages was clicked. Client-side. */
export const TOURNAMENT_CHECK_LOCATION_CLICKED_EVENT = 'tournament_check_location_clicked';
